import { PercentMetricChart } from '../../../renderers/percent-metric-chart/percent-metric-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { FILL_RATE_TOTAL_METRIC_CHART_DEFINITION } from './fill-rate-total-metric-chart.definition';
import { FILL_RATE_TOTAL_METRIC_CHART_MOCK_DATA } from './fill-rate-total-metric-chart.mock';

export const FillRateTotalMetricChart = (props: ChartRendererProps) => <PercentMetricChart {...props} />;

FillRateTotalMetricChart.definition = FILL_RATE_TOTAL_METRIC_CHART_DEFINITION;
FillRateTotalMetricChart.mockData = FILL_RATE_TOTAL_METRIC_CHART_MOCK_DATA;
